import {Profile} from 'feedback-system/dto/IProfile';

import {FETCH_USER_REQUEST, FETCH_USER_SUCCESS, FETCH_USER_FAILURE, CLEAR_USER_ACTION} from './constants';

import {FetchUserRequest, FetchUserSuccess, FetchUserFailure, ClearUser} from './typedef';

type IActions = FetchUserRequest | FetchUserSuccess | FetchUserFailure | ClearUser;

const authenticated = (state: Profile | null = null, action: IActions) => {
    switch (action.type) {
        case FETCH_USER_REQUEST:
            return null;
        case FETCH_USER_SUCCESS:
            return action.payload || null;
        case FETCH_USER_FAILURE:
            return null;
        case CLEAR_USER_ACTION:
            return null;
        default:
            return state;
    }
};

export {authenticated};
